enum LogicalValue {
    True = '1',
    False = '0',
    Indeterminate = ''
}

export default LogicalValue;